import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  overflow: hidden;

  p,
  strong,
  label,
  small,
  h1 {
    font-family: 'Inter', sans-serif;
  }
  strong {
    font-weight: bold;
  }

  @media (max-width: 768px) {
    height: auto;
    min-height: 100vh;
    overflow: visible;
  }
`;

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: hidden;

  @media (max-width: 768px) {
    min-height: auto;
    overflow: visible;
  }
`;
